@if (activityRecordLoaded) {
  <div class="tea-activity-detail">
    <div class="activity-detail">
      <p class="activity-title" data-cy="activity-title">{{ activityRecord.record.title }}</p>
      <div class="user-info">
        <img data-cy="student-avatar" [src]="activityRecord.student.avatar" alt="avatar" />
        <div class="student-name">
          <a [routerLink]="['/students/teacher', activityRecord.student.id]" class="spen-util-link" data-cy="student-name">
            {{ activityRecord.student.name }}
          </a>
          <p data-cy="student-class">{{ activityRecord.student.class_name }}{{ activityRecord.student.attendance_number }}番</p>
        </div>
      </div>
      <div class="additional-info">
        <div class="time-detail">
          <span data-cy="activity-created-at">作成日時：{{ activityRecord.created_at }}</span>
          @if (isUpdated) {
            <span data-cy="activity-updated-at">更新日時：{{ activityRecord.updated_at }}</span>
          }
        </div>
        <p class="activity-type" data-cy="activity-type">種別：{{ activityType }}</p>
        @if (activityRecord.is_answer) {
          <div class="work-name">
            <span>配信課題名：</span>
            @if (workPath) {
              <a
                data-cy="work-title"
                [routerLink]="workPath"
                [queryParams]="{ space_id: activityRecord.space_id }"
                class="spen-util-link"
                >{{ activityRecord.work.title }}</a
              >
            } @else {
              <span class="work_deleted">※課題は削除されました</span>
            }
          </div>
        }
      </div>
      <div class="record-detail">
        @if (isDocumentRecord()) {
          <app-document-detail-teacher
            [document]="activityRecord.record"
            [categoryName]="activityRecord.category_name"
            [marks]="activityRecord.marks"
            [isCompassAnswer]="activityRecord.is_compass_answer"
          >
          </app-document-detail-teacher>
        }
        @if (isQuestionnaireRecord()) {
          <app-questionnaire-detail-teacher [categoryName]="activityRecord.category_name" [questionnaire]="activityRecord.record">
          </app-questionnaire-detail-teacher>
        }
      </div>
    </div>
    <div>
      @if (displayedAlbums.length > 0) {
        <div class="block-info">
          <p class="title">追加先アルバム：</p>
          <div class="links">
            @for (album of displayedAlbums; track album.id) {
              <a
                class="spen-util-link"
                data-cy="displayed-albums"
                [routerLink]="['/albums/teacher', album.id, 'students', activityRecord.student.id]"
              >
                {{ album.title }}
              </a>
            }
            @if (canShowMoreAlbums) {
              <a class="spen-util-link" data-cy="more-albums" (click)="showMoreAlbums()">
                他{{ activityRecord.albums.length - displayedAlbums.length }}件<i class="fa fa-chevron-down"></i>
              </a>
            }
          </div>
        </div>
      }
      @if (displayedSpaces.length > 0) {
        <div class="block-info">
          <p class="title">公開先スペース：</p>
          <div class="links">
            @for (space of displayedSpaces; track space.id) {
              <a class="spen-util-link" data-cy="displayed-spaces" [routerLink]="['/spaces/teacher', space.id]">{{ space.name }}</a>
            }
            @if (canShowMoreSpaces) {
              <a class="spen-util-link" data-cy="more-spaces" (click)="showMoreSpaces()">
                他{{ activityRecord.public_spaces.length - displayedSpaces.length }}件<i class="fa fa-chevron-down"></i>
              </a>
            }
          </div>
        </div>
      }
    </div>
    @if (isDocumentRecord()) {
      <app-tab-view [tabOptions]="tabOptions"></app-tab-view>
      @switch (currentTab) {
        @case ('cross_assessment') {
          <app-cross-assessment-list [activityRecord]="activityRecord"></app-cross-assessment-list>
        }
        @case ('pickup') {
          <app-teacher-pickups-list [activityRecord]="activityRecord"></app-teacher-pickups-list>
        }
        @case ('teacher_assessment') {
          <app-assessment-list-teacher [activityRecord]="activityRecord"></app-assessment-list-teacher>
        }
      }
    }
    @if (activityRecord.record.commented_user) {
      <div class="questionnaire-comment">
        <h2>コメント</h2>
        <div class="comment">
          <div class="user-info">
            <img [src]="activityRecord.record.commented_user.avatar" />
            <div class="user-name">
              <p class="truncate-text">{{ activityRecord.record.commented_user.name }}</p>
              <p>先生</p>
            </div>
          </div>
          <div class="content-comment">
            <p class="time-comment">{{ activityRecord.record.commented_at }}</p>
            <app-read-more [content]="activityRecord.record.commented_text"></app-read-more>
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}
